import type { BranchMiniEntity } from "@/features/branch/domain/entities/BranchMiniEntity";
import type { OrderStatus } from "@/features/order/domain/enums/OrderStatus";
import type { RegionMiniEntity } from "@/features/region/domain/entities/RegionMiniEntity";
import type { UserMiniEntity } from "@/features/user/domain/entities/UserMiniEntity";
import type { VehicleTemplateType } from "@/features/vehicleTemplate/domain/enums/VehicleTemplateType";

export class OrderStreamFilterEntity {
  fetchAll: boolean = true;  
  orderStatuses: OrderStatus[] = []; 
  regions!: RegionMiniEntity[];
  user?: UserMiniEntity;
  fromDate?: string;
  toDate?: string;
  branch?: BranchMiniEntity;
  trackingPanelUser?: UserMiniEntity;
  shipmentDriver?: {
    id?: number;
    workingPhoneNumber?: string | null;
    fullName?: string | null;
    vehicleTemplateType?: VehicleTemplateType;
  };
}
 